import TickmarkGenerator from './TickmarkGenerator'

export default TickmarkGenerator
